import React, { useState } from "react";
import './style.css';
//import { AiOutlineSearch } from "react-icons/ai";
import { Collapse } from "react-collapse";
//import { NavLink } from 'react-router-dom'
import { IoIosArrowDown } from "react-icons/io";
import SideNav from './../../../components/SideNav_OG';
import PedidosInstituicao from './../../../components/Display_Organizador/Listar_Agentes/Insituicao';
import PedidosProfissional from './../../../components/Display_Organizador/Listar_Agentes/Profissional da saude';

export default function Tela_Pedidos_de_Inscricao() {
  //let [search, setSearch] = useState(false);
  let [options, setOptions] = useState(false);
  let [options3, setOptions3] = useState(false);
  return(
    <>
        <SideNav />
        <div id="top_pi"></div>
        
        <div id="main-pi">
                    <p id="Pedidos">Solicitações de instituições</p>
                    <hr id="divider-Pedidos" />
                    <div id="arrow-Pedidos">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions(!options)
                            }
                            size={"6vh"}
                            id="IconDown-Pedidos"
                        />
                    </div>
                    <Collapse isOpened={options}>
                        <div id="collapsed-Pedidos">
                            <PedidosInstituicao/>
                         </div>
                    </Collapse>

                    <p id="Pedidos">Solicitações de profissionais da saúde</p>
                    <hr id="divider-Pedidos" />
                    <div id="arrow-Pedidos">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions3(!options3)
                            }
                            size={"6vh"}
                            id="IconDown-Pedidos"
                        />
                    </div>
                    <Collapse isOpened={options3}>
                        <div id="collapsed-Pedidos">
                            <PedidosProfissional/>
                        </div>
                    </Collapse>
            </div>

    </>
  );
}